import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import {
  IAvailableRegionalManagersParams,
  IAvailableRegionalManagersResponse,
  IRegMenByPeriodResponse,
  IRegMenConsolidateResponse,
  IRegMenReportFilters,
  IReportFileHash,
} from "~/entity/RegMenReports/model/schema";
import { cleanObject } from "~/shared/lib/cleanObject";

const regMenReportsServiceMap = {
  byPeriod: "/user/reports/reg-men-by-dealer-by-period",
  consolidate: "/user/reports/reg-men-by-dealer-consolidate",
  availableRegionalManagers: "/user/available-regional-managers",
};

/**
 * Собирает query string для GET-отчётов. Массивы и вложенный dealerGroup
 * сериализуются в qs-формате (ids[]=1&dealerGroup[cities][]=...),
 * как принято на бэкенде (NestJS).
 */
export const buildRegMenReportQuery = (
  filters: IRegMenReportFilters = {},
): string => {
  const params = new URLSearchParams();

  filters.ids?.forEach((id) => params.append("ids[]", String(id)));

  const group = filters.dealerGroup;
  group?.ids?.forEach((id) => params.append("dealerGroup[ids][]", String(id)));
  group?.cities?.forEach((value) =>
    params.append("dealerGroup[cities][]", value),
  );
  group?.FOs?.forEach((value) => params.append("dealerGroup[FOs][]", value));
  group?.countries?.forEach((value) =>
    params.append("dealerGroup[countries][]", value),
  );
  group?.subjects?.forEach((value) =>
    params.append("dealerGroup[subjects][]", value),
  );

  if (filters.regionalManagerId)
    params.append("regionalManagerId", String(filters.regionalManagerId));
  if (filters.assignmentType)
    params.append("assignmentType", filters.assignmentType);
  if (filters.actualOn) params.append("actualOn", filters.actualOn);
  if (filters.quarter) params.append("quarter", String(filters.quarter));
  if (filters.year) params.append("year", String(filters.year));

  const query = params.toString();
  return query ? `?${query}` : "";
};

export class RegMenReportsService {
  static GET = {
    getRegMenByDealerByPeriod: (
      filters: IRegMenReportFilters,
    ): NetworkResponse<IRegMenByPeriodResponse> =>
      requestREST.get(
        `${regMenReportsServiceMap.byPeriod}${buildRegMenReportQuery(filters)}`,
      ),
    getRegMenByDealerConsolidate: (
      filters: IRegMenReportFilters,
    ): NetworkResponse<IRegMenConsolidateResponse> =>
      requestREST.get(
        `${regMenReportsServiceMap.consolidate}${buildRegMenReportQuery(filters)}`,
      ),
    getAvailableRegionalManagers: ({
      search,
      page = 1,
      limit = 25,
    }: IAvailableRegionalManagersParams): NetworkResponse<IAvailableRegionalManagersResponse> => {
      const params = new URLSearchParams();
      if (search) params.append("search", search);
      params.append("page", String(page));
      params.append("limit", String(limit));
      return requestREST.get(
        `${regMenReportsServiceMap.availableRegionalManagers}?${params.toString()}`,
      );
    },
  };

  static POST = {
    getRegMenByDealerByPeriodFile: (
      filters: IRegMenReportFilters,
    ): NetworkResponse<IReportFileHash> =>
      requestREST.post(
        regMenReportsServiceMap.byPeriod,
        cleanObject(filters) as IRegMenReportFilters,
      ),
    getRegMenByDealerConsolidateFile: (
      filters: IRegMenReportFilters,
    ): NetworkResponse<IReportFileHash> =>
      requestREST.post(
        regMenReportsServiceMap.consolidate,
        cleanObject(filters) as IRegMenReportFilters,
      ),
  };
}
